import Vue from 'vue'
import Router from 'vue-router'

// Components
import IndexComponent from '@/components/IndexComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'IndexComponent',
      component: IndexComponent
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js